import { ParseService } from 'app/shared/common/parse/parse.service';
import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Injectable({
  providedIn: 'root'
})

export class TimesheetReport {
  value: Date;
  data: any[] = [];
  cols: any[];
  starDay: any;
  requiredInfo = [];
  rankResult: any[] = [];
  thenTimes = 0;
  userCompleted: boolean = false;
  innerThenTimes = 0;
  isloaded = false;
  totalWorkingDays = 0;
  holidaysList = [];
  skipingUsers = [];


  constructor(
    private parseService: ParseService,
    private dateServiceService: DateServiceService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration
  ) {


  }

  async getReport(date) {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', new Date(date).getFullYear());
    this.holidaysList = await holidayQuery.find();
    this.skipingUsers = ['BIfNZHDTsc', 'NJt11DneE5', 'Hp5r6v7CwS', 'VfbstJqMJw'];
    let result = await this.getReportingToList(date);
  }

  getLeaveWorkingDays(date) {
    const d = new Date(date);
    let holidayList = this.holidaysList[0].get('dateList') == undefined ? {} : this.holidaysList[0].get('dateList');
    let holidays = holidayList[d.getMonth()];

    const leaveDays = [];
    const workingDays = [];
    const getTot = this.daysInMonth(d.getMonth(), d.getFullYear(), d.getDate());
    const sat = [];
    const sun = [];

    for (let i = 1; i <= getTot; i++) {

      const newDate = new Date(d.getFullYear(), d.getMonth(), i);
      if (newDate.getDay() == 0) {
        sun.push(i);
      }
      if (newDate.getDay() == 6) {
        sat.push(i);
      }
      if (newDate.getDay() != 6 && newDate.getDay() != 0) {
        workingDays.push(i);
      }

    }

    sun.forEach(s => {
      leaveDays.push(s);
    });
    sat.forEach((sa, index) => {
      if (index % 2 == 0) {
        leaveDays.push(sa);
      } else {
        workingDays.push(sa);
      }
    });

    holidays.forEach(element => {
      let index = workingDays.findIndex(x => x == element);
      if (index != -1) {
        workingDays.splice(index, 1);
        leaveDays.push(element);
      }
    });
    let workDates = workingDays.sort(function (a, b) { return a - b; });
    workDates.forEach((element, index) => {
      let datePipe = new DatePipe('en-US');
      workDates[index] = datePipe.transform(new Date(d.getFullYear(), d.getMonth(), element), 'MM/dd/yyyy');
    });
    let leaveDates = leaveDays.sort(function (a, b) { return a - b; });
    leaveDates.forEach((element, index) => {
      let datePipe = new DatePipe('en-US');
      leaveDates[index] = datePipe.transform(new Date(d.getFullYear(), d.getMonth(), element), 'MM/dd/yyyy');
    });

    return { workDays: workDates, leaveDay: leaveDates };
  }

  daysInMonth(month, year, date) {
    return new Date(year, month, date).getDate();
  }

  async getReportingToList(date) {
    this.spinner.show();
    let isActive: any;
    let isLongLeave: any;
    this.requiredInfo = [];
    const attend = this.parseService.instance.Object.extend('User');
    const query = new this.parseService.instance.Query(attend);
    query.include('profile');
    query.include('profile.isActive');
    query.include('profile.department');
    query.include('profile.location');
    query.include('profile.role');
    query.notContainedIn('objectId', this.skipingUsers);
    query.limit(1500);

    await query.find().then(results => {
      this.toastr.success('Report Generation Started');
      results.forEach(element => {
        let profileClass = element.get('profile');
        if (profileClass != undefined) {
          isActive = profileClass.get('isActive');
          isLongLeave = profileClass.get('isLongLeave');
          let departmentDetails = profileClass.get('department');
          let department = departmentDetails.get('name');
          let locationDetails = profileClass.get('location');
          let location = locationDetails.get('name');
          let roleDetails = profileClass.get('role');
          let role = roleDetails.get('name');
          let officialDetails = profileClass.get('officialInfo');
          let startTime = officialDetails.startTime;
          if (startTime != undefined && isActive && !isLongLeave) {
            let userId = element.id;
            let profileId = profileClass.id;
            let userName = profileClass.get('firstName') + ' ' + profileClass.get('lastName');
            let reportingTo = profileClass.get('reportingTo');
            let reporterUsername = reportingTo.get('username');
            let userEmail = officialDetails.officialEmail;
            let gitAcc = officialDetails.gitUserId;
            this.requiredInfo.push({
              userId: userId,
              profileId: profileId,
              userName: userName,
              userEmail: userEmail,
              startTime: startTime,
              reportingId: reportingTo.id,
              reporterUsername: reporterUsername,
              department: department,
              location: location,
              role: role,
              gitAcc: gitAcc
            });
          }
        }
      });
      this.spinner.hide();
      let result = this.getTimeSheetInfo(date);
      return result;
    }).catch(err => {
      this.spinner.hide();
      this.toastr.warning('Something Went wrong');
      return false;
    });
  }

  async getTimeSheetInfo(filteredDate) {

    this.spinner.show();
    let date = new Date(filteredDate);
    let today = date.getDate() <= 1 ? new Date(date.getFullYear(), date.getMonth(), 0) : date;
    let startEndDate = this.dateServiceService.startEndDateByMonth(today);
    let leaveDays = this.getLeaveWorkingDays(today);
    // let today = new Date(new Date().setHours(0, 0, 0, 0));
    // let endToday = new Date(new Date().setHours(23, 59, 59, 999));
    // let startDate = new Date(new Date(today.setDate(1)).setMonth(8));
    // let endDate = new Date(new Date(endToday.setDate(30)).setMonth(8));
    // let startDate = new Date(new Date(today.setDate(1)).setMonth(5));
    // let endDate = new Date(new Date(endToday.setDate(30)).setMonth(5));
    for (let i = 0; i < this.requiredInfo.length; i++) {
      let errorDates = [];
      this.requiredInfo[i].onTime = 0;
      this.requiredInfo[i].hoursCount = 0;
      this.requiredInfo[i].workhours = 0;
      this.requiredInfo[i].tenHoursCount = 0;
      this.requiredInfo[i].presentDays = 0;
      this.requiredInfo[i].violationDays = 0;
      this.requiredInfo[i].errorDates = [];
      let instance = this.parseService.instance.Object.extend('UserTimeSheet');
      let query = new this.parseService.instance.Query(instance);
      let userId = this.requiredInfo[i].userId;
      let userClass = new this.parseService.instance.Object('_User');
      userClass.id = userId;
      query.equalTo('user', userClass);
      query.greaterThan('createdAt', startEndDate[0]);
      query.lessThan('createdAt', startEndDate[1]);
      query.limit(10000);
      const results = await query.find();
      if (results.length == 0) {
        this.requiredInfo[i].onTime = 0;
        this.requiredInfo[i].hoursCount = 0;
        this.requiredInfo[i].tenHoursCount = 0;
        this.requiredInfo[i].workhours = 0;
        this.requiredInfo[i].presentDays = 0;
        this.requiredInfo[i].violationDays = 0;
      } else {
        results.forEach((innerElement) => {
          let totalDays = [];
          let createDate = innerElement.get('createdAt');
          let starttimeDaily = innerElement.get('agreedStartTime');
          let skipDate = leaveDays.leaveDay;
          let datePipe = new DatePipe('en-US');
          if (new Date(today).getMonth() == new Date().getMonth()) {
            let dateToday = today.toString();
            let dateTodayString = datePipe.transform(dateToday, 'MM/dd/yyyy');
            skipDate.push(dateTodayString);
            let dateSplit = dateTodayString.split('/');
            let currentDateStr = dateSplit[1];
            let currentDate = parseInt(currentDateStr);
          }
          // for (let j = 0; j <= 30; j++) {
          // for (let j = 1; j < currentDate; j++) {
          //   let allDates = new Date(new Date(new Date().setDate(j)).setMonth(8));
          //   let datesToString = allDates.toString();
          //   let transformDate = datePipe.transform(datesToString, 'MM/dd/yyyy');
          //   totalDays.push(transformDate);
          // }
          totalDays = leaveDays.workDays;
          skipDate.forEach(skipElement => {
            let actualWorkDays = totalDays.filter(x => x != skipElement);
            totalDays = actualWorkDays;
          });
          this.totalWorkingDays = totalDays.length;
          let date = createDate.toString();
          let startDate = datePipe.transform(date, 'MM/dd/yyyy');
          let createStringDate = startDate.toString();
          let filter = skipDate.filter(x => x == createStringDate).length > 0;
          if (filter == false) {
            let loginTime = innerElement.get('inTime');
            let startingTime = this.requiredInfo[i].startTime;
            // let graceStartTime = new Date(new Date(startDate + ' ' + startingTime).getTime() + (16 * 60 * 1000));
            let graceStartTime = new Date(new Date(startDate + ' ' + starttimeDaily).getTime() + (16 * 60 * 1000));
            if (loginTime < graceStartTime.getTime()) {
              this.requiredInfo[i].onTime = this.requiredInfo[i].onTime + 1;
            }
            let workAttendance = innerElement.get('totalAttendance');
            let workTime = workAttendance.worktime;
            if (workTime >= 28800) {
              this.requiredInfo[i].hoursCount = this.requiredInfo[i].hoursCount + 1;
            }
            if (workTime >= 36000) {
              this.requiredInfo[i].tenHoursCount = this.requiredInfo[i].tenHoursCount + 1;
            }
            this.requiredInfo[i].presentDays = this.requiredInfo[i].presentDays + 1;
            this.requiredInfo[i].workhours = this.requiredInfo[i].workhours + workTime;
            if (workTime > 54000) {

              this.requiredInfo[i].violationDays = this.requiredInfo[i].violationDays + 1;
              errorDates.push(createStringDate);
              this.requiredInfo[i].errorDates = errorDates.toString();
            }
          }
        });
      }
    }
    this.spinner.hide();
    this.sortResult(filteredDate);
  }

  async sortResult(filteredDate) {
    this.spinner.show();
    this.rankResult = this.requiredInfo.sort((a, b) => {
      if (a.onTime > b.onTime) { return -1; }
      if (a.onTime < b.onTime) { return 1; }
      if (a.hoursCount > b.hoursCount) { return -1; }
      if (a.hoursCount < b.hoursCount) { return 1; }
      if (a.workhours > b.workhours) { return -1; }
      if (a.workhours < b.workhours) { return 1; }
    });
    this.rankResult.forEach((element, index) => {
      element.rank = index + 1;
      let workingHours = element.workhours / 3600;
      let reduceString = workingHours.toFixed(2);
      let convertFloat = parseFloat(reduceString);
      element.workhours = convertFloat;
      element.absentDays = this.totalWorkingDays - element.presentDays;
    });
    let datePipe = new DatePipe('en-US');
    let todayDate = datePipe.transform(new Date(filteredDate), 'MM/dd/yyyy');

    var query = new this.parseService.instance.Query('TimeSheetReport');
    query.equalTo('reportDate', todayDate);
    query.limit(100000000000);
    let queryResult = await query.find();
    if (queryResult.length > 0) {
      this.parseService.instance.Object.destroyAll(queryResult);
    }
    this.createRecords(this.rankResult, filteredDate);
    this.isloaded = true;
    this.spinner.hide();
  }

  createRecords(rankDetails, filteredDate): any {
    this.spinner.show();
    let datePipe = new DatePipe('en-US');
    rankDetails.forEach(element => {
      let reportClass = this.parseService.instance.Object.extend('TimeSheetReport');
      let reportDetails = new reportClass();
      let reportDate = datePipe.transform(new Date(filteredDate), 'MM/dd/yyyy');
      reportDetails.set('rank', element.rank);
      reportDetails.set('reportDate', reportDate);
      reportDetails.set('user', { __type: 'Pointer', className: '_User', objectId: element.userId });
      reportDetails.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: element.reportingId });
      reportDetails.set('reportDetails', {
        userName: element.userName,
        startTime: element.startTime,
        department: element.department,
        location: element.location,
        role: element.role,
        onTime: element.onTime,
        hoursCount: element.hoursCount,
        tenHoursCount: element.tenHoursCount,
        workhours: element.workhours,
        presentDays: element.presentDays,
        absentDays: element.absentDays < 0 ? 0 : element.absentDays,
        violationDays: element.violationDays,
        errorDates: element.errorDates,
      });
      reportDetails.save();
    });
    this.toastr.success('Report Generated Successfully');
    this.spinner.hide();
  }


}
